import Loader from "react-loader";
import { useTranslation } from "react-i18next";
import { Alert } from "components/atoms/Alert.atom";
import { Modal } from "react-bootstrap";
import { useState } from "react";
import { InventoryLocationsList } from "./InventoryLocationRow";
import { FontSize, Text } from "components/atoms/Text.atom";
import { useTopExceededCapacityHook } from "pages/inventoryview/react-queries/TopExceededCapacity";

type ParamsType = {
  redirectToInsightsView: (locationId: number) => void;
  resetSearchAndFilters: () => void;
};

export const TopExceededCapacity = ({
  redirectToInsightsView,
  resetSearchAndFilters,
}: ParamsType) => {
  const { t } = useTranslation("inv-dashboard");
  const [show, setShow] = useState(false);
  const [filter, setFilterData] = useState({
    name: null,
    queryKey: null,
    searchOption: null,
  });

  const {
    listOfLocations,
    isFetching: isLoading,
    isError,
  } = useTopExceededCapacityHook();

  const title = t("inv-dashboard:Top Exceeded Capacity");
  const popupTitle = t(
    "inv-dashboard:Top Exceeded Capacity: [[[filterName]]] (Shippable On Site VINs)",
    { filterName: filter?.name, keySeparator: ":" },
  );

  /**
   * Pagination applied in modal popup
   * Manual pagination applied as API response includes list of all locations
   */
  const PAGE_SIZE = 10;
  /**
   * Display only 12 rows in the widget
   */
  const BASE_TABLE_PAGE_SIZE = 12;
  const firstPageOfLocations = listOfLocations.slice(0, BASE_TABLE_PAGE_SIZE);

  return (
    <>
      <div>
        {isLoading ? (
          <Loader loaded={false} />
        ) : (
          !isError && (
            <InventoryLocationsList
              inventoryItemsList={firstPageOfLocations}
              title={title}
              displayShowMoreButton={
                listOfLocations.length > BASE_TABLE_PAGE_SIZE
              }
              showMoreClickHandler={() => setShow(true)}
              pageSize={BASE_TABLE_PAGE_SIZE}
              locationRowClickHandler={(locationId) => {
                resetSearchAndFilters();
                redirectToInsightsView(locationId);
              }}
              displayPaginationControls={false}
              showTotalCapacity={true}
              showCurrentCapacity={true}
            />
          )
        )}
        <Alert show={isError}>
          {t("inv-dashboard:Unable to fetch details. Please try again later.")}
        </Alert>
      </div>
      <Modal
        backdrop={"static"}
        show={show}
        onHide={() => {
          setFilterData({
            name: null,
            searchOption: null,
            queryKey: null,
          });
          setShow(false);
        }}
        size="lg"
      >
        <Modal.Header closeButton className="bg-light text-body">
          <Text
            size={FontSize.size18}
            style={{ marginBottom: 2 }}
            as="div"
            bold
          >
            {t("inv-dashboard:Details")}
          </Text>
        </Modal.Header>
        <Modal.Body>
          <div css={{ minHeight: 250 }}>
            {isLoading ? (
              <Loader loaded={false} />
            ) : (
              listOfLocations.length > 0 && (
                <InventoryLocationsList
                  inventoryItemsList={listOfLocations}
                  title={popupTitle}
                  displayPaginationControls={true}
                  pageSize={PAGE_SIZE}
                  locationRowClickHandler={(locationId) => {
                    resetSearchAndFilters();
                    redirectToInsightsView(locationId);
                  }}
                  showTotalCapacity={true}
                  showCurrentCapacity={true}
                />
              )
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
